import i18next from 'i18next';

export function formatOfferDayLabel(day: number): string {
  if (day < 0) {
    return String(i18next.t('offer-input-header-preday'));
  }
  return `${String(i18next.t('offer-input-header-day'))} ${day + 1}`;
}
